<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>
      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>{{ $t('User') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
          autocomplete="off"
        >
          <v-container class="mt-5">
            <v-row>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="model.username"
                  :label="$t('User name')"
                  :error-messages="errors.username"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="model.password"
                  type="password"
                  :label="$t('Password')"
                  :error-messages="errors.password"
                  autocomplete="off"
                  :hint="$t('Minimal 10 characters of which contains, 1 uppercase, 1 lowercase, 1 digit, 1 special character (!@#$%^&*)')"
                ></v-text-field>
                <v-text-field
                  v-model="model.first_name"
                  :label="$t('Firstname')"
                  :error-messages="errors.first_name"
                ></v-text-field>

                <v-text-field
                  v-model="model.last_name"
                  :label="$t('Lastname')"
                  :error-messages="errors.last_name"
                ></v-text-field>

                <v-select
                  v-model="model.roles"
                  :items="Object.values(availableRoles)"
                  item-text="description"
                  item-value="name"
                  :label="$t('Role')"
                  :error-messages="errors.roles"
                  multiple
                  chips
                ></v-select>


              </v-col>
              <v-col cols="6" sm="6">
                <v-switch
                  v-model="model.status"
                  :label="$t('Active')"
                  :error-messages="errors.status"
                ></v-switch>
                <v-switch
                  v-model="model.resetauth"
                  :label="$t('Reset google authentication')"
                  :error-messages="errors.status"
                ></v-switch>
              </v-col>

            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveItem">{{ isNewItem ? $t('Create') : $t('Save') }}</v-btn>
        <v-btn color="default" @click="hideDialog">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>

    </v-card>

	<ErrorFlash v-model="errors"/>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'
import { mapState } from 'vuex'
import ErrorFlash from '@/components/ErrorFlash'

export default {
  components: {
    ErrorFlash,
  },
  data () {
    return {
      dialogState: false,

      model: {
        id: null,
        username: null,
        password: null,
        email: null,
        roles: [],
        status: null,
        resetauth: false,
      },

      errors: {},

    }
  },
  computed: {
    isCompany() {
      return this.model.company_name !== null && this.model.company_name.length
    },
    isNewItem() {
      return !this.model.id
    },
    ...mapState('auth', {
      availableRoles: state => state.roles,
    }),
  },
  created() {
    this.$store.dispatch('auth/fetchRoles')
  },
  methods: {
    showDialog(id = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false
      this.setItem({}, true)
    },
    setItem(item = {}, overwrite = false) {
      Object.keys(this.model).forEach(key => {
        if (overwrite || (key in item)) {
          this.model[key] = item[key] || null
        }
      })
      this.errors = {}
    },
    getItem() {
      const item = this.model
      item.status = item.status ? 10 : 0
      item.resetauth = item.resetauth ? true : false
      return item
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/users/${id}`, {
        params: {
          expand: 'roles',
        },
      }).then(item => {
        this.setItem(item, true)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    saveItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      if (this.model.id) {
        ApiService.update(`/users/${this.model.id}`, {
          ...this.getItem(),
        }).then(item => {
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      } else {
        ApiService.create('/users', {
          ...this.getItem(),
        }).then(item => {
          this.setItem(item)
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      }
    },
  },
}
</script>
